module.exports = __webpack_public_path__ + "static/media/teodora-petrovic.7e30a852.jpg";